import * as React from 'react';
import {
  withStyles,
  WithStyles,
} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import {connect} from 'react-redux';
import * as EconomyActions from '@services/economy/economy.actions';
import CordovaContext from '../../../cordovaContext';
import {Repeat} from "@material-ui/icons";
import {
  BoxedRow,
  Col,
  CustomCheckbox,
  CustomDialogContent,
  CustomSelectInverted,
  CustomTextFieldInvertedP,
  NoPrice,
  Row,
  StyledInputAdornment,
  StyledLabel,
  dialogStyles,
} from '../DialogComponens';
import { EcoRepeat, IEcoSplit, INewEcoAgreement } from '@app-types/websocket/economy.types';

const tn = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof dialogStyles>{
  text: string;
  childId: number;
  next: () => void;
  currency:string;
  split:IEcoSplit[];

  repeat:EcoRepeat;
  repeatEditable:boolean;
  desc:string;

  newAgreement: (values:INewEcoAgreement) => void;
}

interface IState {
  price:number;
  setPrice:boolean;
  repeat:EcoRepeat;
}


class StepOneCost extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      price:0,
      setPrice: true,
      repeat:props.repeat,
    };
    
  }

  public render() {
    const { text, next } = this.props;
    const {price, repeat} = this.state;

    return (<>
        <CustomDialogContent >
          <BoxedRow style={{fontWeight: 500, fontSize: '17px'}}>
            {text}
          </BoxedRow>
          <BoxedRow>
            <Col style={{ flex: 1, alignItems: 'flex-start', justifyContent: 'center', minWidth: 110 }}>
              <StyledLabel htmlFor="setPrice">{tn.lang.agreementEstimatePrice}
                <CustomCheckbox color="default" id="setPrice" checked={this.state.setPrice} 
                  onClick={() => this.setState({setPrice:!this.state.setPrice})}/>
              </StyledLabel>
            </Col>
            <Col>
            {this.state.setPrice
              ?<CustomTextFieldInvertedP
                name="amount"
                id="amount"
                value={(price === undefined || price===0)?"":price}
                placeholder={(price === undefined || price===0)?"0":undefined}
                onChange={(e) => this.setState({price:(e.target.value.length > 0?Number.parseInt(e.target.value,10):0)})}
                type="number" 
                inputMode="numeric"
                autoFocus={true}
                tabIndex={1}
                autoComplete="off"
                InputProps={{
                  disableUnderline: true,
                  endAdornment: (<StyledInputAdornment position="end" disableTypography={true}>{this.props.currency}</StyledInputAdornment>),
                }}
                InputLabelProps={{ shrink: false }}
              />
              :<NoPrice>{tn.lang.agreementNoPrice}</NoPrice>
            }
              
            </Col>
          </BoxedRow>
          {this.props.repeatEditable && <BoxedRow style={{ flex: 1 }}>
                  <StyledLabel htmlFor="repeat" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1, gap:'8px', }}>
                    <Repeat style={{fontSize:'10px'}} /> <span>{tn.lang.repeat}</span>
                  </StyledLabel>
                  <Col>
                  <CustomSelectInverted
                      name="repeat"
                      value={repeat}
                      onChange={(e) => {const v:string = (typeof e.target.value === 'string')? e.target.value:"ONCE"; 
                        this.setState({repeat:EcoRepeat[v as keyof typeof EcoRepeat]});}}
                      displayEmpty={true}
                      disableUnderline={true}
                      data={Object.values(EcoRepeat).map((option: string) => ({value:option, element:<>{tn.lang.repeatOption(option)}</>}))}
                    />
                  </Col>
              </BoxedRow>}
        </CustomDialogContent>
        <Row style={{justifyContent: 'flex-end', padding: '20px'}}>
          <Button onClick={() => next()} color='default' variant='contained' size="large">
            {tn.lang.no}
          </Button>
          <Button onClick={() => this.createNew()} color='primary' variant='contained' size="large">
            {tn.lang.add}
          </Button>
        </Row></>
    );
  }

  private createNew() {
    const newAgreement:INewEcoAgreement = {
      title: this.props.desc,
      children: [this.props.childId],
      currency: this.props.currency,
      images: [],
      responsible: [],
      repeat: this.state.repeat,
      split: this.props.split,
      amount: this.state.setPrice?this.state.price:0,
      autoAccept: true,
    };
    
    this.props.newAgreement(newAgreement);
    this.props.next();
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
    family: state.family.family,
  };
}

const mapDispatchToProps = {
  newAgreement: EconomyActions.newAgreement,
};


StepOneCost.contextType = CordovaContext;

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(dialogStyles)(StepOneCost));



// WEBPACK FOOTER //
// ./src/components/economy/setup/StepOneCost.tsx